/**
 * List of all regex used inside app for form validation
 * @example regexForm.email
 */
const regexForm = {
    accountUsername: /^[0-9A-Za-z_-]{1,80}$/,
    password: /^.{8,255}$/,
    organisationName: /^.{1,255}$/,
    firstname: /^.{1,255}$/,
    lastname: /^.{1,255}$/,
    name: /^.{1,100}$/,
    description: /^(.|\n){1,1000}$/,
    zipCode: /^[A-Z0-9\s-]{1,10}$/,
    cityRegion: /^.{1,255}$/,
    adress: /^.{1,255}$/,
    simpleText: /^.{1,255}$/,
    country: /^[A-Z]{2}$/,
    email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    fieldOfAction: /^[A-Z]+$/,
    phone: /^[+]\d{3}\s(\(0\))[ \d]{8,}$/,
    role: /^[A-Z]+$/,
    url: /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/,
    siret: /(\d{3}[\s]\d{3}[\s]\d{3}[\s]\d{5})/,
    iban: /FR[0-9]{2}[\s][0-9]{4}[\s][0-9]{4}[\s][0-9]{4}[\s][0-9]{4}[\s][0-9]{4}[\s][0-9]{3}$/,
    partnershipGroup: /^[-\wÀ-ž]{1,80}$/,
    imageFile: /(.*?)\.(png|jpg|jpeg|svg)$/,
};

export default regexForm;
